import { useCurrentUser } from "#/components/context/user/UserContext"
import { OriginDialogContext } from "#/components/telemedicine/pelvic-floor-therapy/OriginDialogContext"
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from "@carrotfertility/carotene-core"
import React, { useContext } from "react"
import { FormattedMessage } from "react-intl"

export function SignInAsMemberStep(): JSX.Element {
  const { setOpenDialogFlow } = useContext(OriginDialogContext)
  const { preferredName, firstName } = useCurrentUser()
  return (
    <>
      <DialogTitle>
        <FormattedMessage
          defaultMessage="Sign in with {name}'s account"
          values={{ name: preferredName ?? firstName }}
        />
      </DialogTitle>
      <DialogContent>
        <Typography>
          <FormattedMessage defaultMessage="Please ask the member to sign in to their account to access pelvic floor therapy through Origin." />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenDialogFlow(false)}>
          <FormattedMessage defaultMessage="Close" />
        </Button>
      </DialogActions>
    </>
  )
}
